import { reactive } from 'vue';
import { fetchAssignmentConfigurations } from '@/services/fetchAssignmentConfigurations';
import { AssignmentConfigApiResponse } from '@/pages/OperationsInsights/types/AssignmentConfigurationResponse';

type assignmentConfigStore = {
    data: AssignmentConfigApiResponse | null;
}
type assignmentNamesStore = {
    data: string[];
}
// workloadAssignmentConfigurationsStore
export const useWorkloadAssignmentConfigurationsStore = () => {
    const assignmentConfigurationsStore = reactive<assignmentConfigStore>({ data: null });

    const assignmentAgeBandConfigNamesStore = reactive<assignmentNamesStore>({ data: [] });

    fetchAssignmentConfigurations().then((configurations) => {
        assignmentConfigurationsStore.data = configurations;
        assignmentAgeBandConfigNamesStore.data = [
            ...configurations.globalConfig.ageBandConfig.items.map((i) => i.name),
            configurations.globalConfig.ageBandConfig.defaultAgeBand
        ];
    });

    return { assignmentConfigurationsStore, assignmentAgeBandConfigNamesStore };
};